import { AFFILIATE_URL, getAffiliateLinkProps } from '../../../constants/affiliate';

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[640px] lg:min-h-[700px] flex flex-col justify-center pt-16 overflow-hidden bg-hero-blue">
      {/* Marquee Banner */}
      <div className="absolute top-16 left-0 right-0 z-20 bg-blue-900/60 backdrop-blur-sm border-b border-blue-700/30 overflow-hidden">
        <div className="flex whitespace-nowrap animate-marquee py-2">
          <span className="text-blue-200 text-xs px-8">
            iPAY9 Online Casino Australia — min deposit from AUD 10, withdrawals from AUD 50, secure access and fast payouts, and a Daily Deposit Bonus: deposit AUD 100 to unlock free bonus up to AUD 200.
          </span>
          <span className="text-blue-200 text-xs px-8">
            iPAY9 Online Casino Australia — min deposit from AUD 10, withdrawals from AUD 50, secure access and fast payouts, and a Daily Deposit Bonus: deposit AUD 100 to unlock free bonus up to AUD 200.
          </span>
          <span className="text-blue-200 text-xs px-8">
            iPAY9 Online Casino Australia — min deposit from AUD 10, withdrawals from AUD 50, secure access and fast payouts, and a Daily Deposit Bonus: deposit AUD 100 to unlock free bonus up to AUD 200.
          </span>
        </div>
      </div>

      <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full pointer-events-none"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] rounded-full pointer-events-none"></div>
        <div className="absolute top-1/3 left-1/3 w-[400px] h-[400px] rounded-full pointer-events-none"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 w-full relative z-10">
        <div className="flex flex-col md:flex-row md:items-center gap-8 md:gap-10 lg:gap-12 py-12 md:py-16 lg:py-20 mt-6">
          <div className="flex-1 min-w-0 text-center md:text-left">
            <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-6 animate-float backdrop-blur-sm mx-auto md:mx-0">
              <span className="w-2 h-2 rounded-full bg-blue-300 animate-pulse"></span>
              <span className="text-blue-200 text-xs font-semibold tracking-wider uppercase">Official iPAY9 Online Casino Australia</span>
            </div>
            <h1 className="section-title text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-black text-white leading-tight mb-5">
              <span className="text-gradient-white">iPAY9</span>
              <br />
              <span className="text-blue-200">Online Casino Australia</span>
            </h1>
            <p className="text-blue-200/80 text-sm md:text-[15px] lg:text-base leading-relaxed mb-4 max-w-xl mx-auto md:mx-0">
              iPAY9 Online Casino Australia provides access to slots, live casino, and sportsbook content, featuring games from providers such as JILI, BNG, and VPower, with AUD deposits and straightforward withdrawal options.
            </p>
            <div className="flex flex-wrap gap-4 mb-8 justify-center md:justify-start">
              <div className="flex items-center gap-1.5 text-blue-200/70 text-xs">
                <i className="ri-shield-check-line text-blue-300"></i>
                <span>Min. Deposit AUD 10</span>
              </div>
              <div className="flex items-center gap-1.5 text-blue-200/70 text-xs">
                <i className="ri-flashlight-line text-blue-300"></i>
                <span>Fast Withdrawal AUD 50</span>
              </div>
              <div className="flex items-center gap-1.5 text-blue-200/70 text-xs">
                <i className="ri-lock-line text-blue-300"></i>
                <span>Secure &amp; Licensed</span>
              </div>
            </div>
            <div className="flex flex-row flex-wrap gap-2 sm:gap-4 justify-center md:justify-start w-full max-w-md mx-auto md:max-w-lg md:mx-0 lg:max-w-none">
              <a href={AFFILIATE_URL} {...getAffiliateLinkProps('hero_join_now', 'Join iPAY9 Now')} className="group relative flex-1 min-w-0 overflow-hidden bg-white text-blue-700 font-bold px-3 py-3.5 sm:px-8 sm:py-4 rounded-xl transition-all duration-300 cursor-pointer text-xs sm:text-sm md:text-base text-center hover:scale-105 hover:shadow-[0_8px_30px_rgba(255,255,255,0.3)]">
                <span className="relative z-10 flex items-center justify-center gap-1.5 sm:gap-2">
                  <span className="leading-tight">Join iPAY9 Now</span>
                  <i className="ri-arrow-right-line shrink-0 transition-transform duration-300 group-hover:translate-x-1"></i>
                </span>
              </a>
              <a href={AFFILIATE_URL} {...getAffiliateLinkProps('hero_download_app', 'Download App')} className="group relative flex-1 min-w-0 overflow-hidden border border-white/40 hover:border-white/70 text-white/90 hover:text-white font-semibold px-3 py-3.5 sm:px-8 sm:py-4 rounded-xl transition-all duration-300 cursor-pointer text-xs sm:text-sm md:text-base text-center hover:bg-white/10 hover:scale-105">
                <span className="relative z-10 flex items-center justify-center gap-1.5 sm:gap-2">
                  <i className="ri-smartphone-line shrink-0"></i>
                  <span className="leading-tight">Download App</span>
                </span>
              </a>
            </div>
          </div>

          <div className="relative mx-auto w-full max-w-[340px] shrink-0 md:mx-0 md:max-w-none md:w-[min(42vw,360px)] lg:w-[380px]">
            {/* Layered depth — desktop only */}
            <div className="absolute -inset-6 hidden bg-blue-400/20 blur-3xl rounded-full md:block"></div>
            <div className="absolute -inset-3 hidden bg-gradient-to-br from-white/10 via-blue-300/10 to-transparent blur-2xl rounded-[28px] rotate-1 md:block"></div>

            <div className="relative z-10 overflow-hidden rounded-2xl bg-slate-900/10 ring-1 ring-white/25 shadow-[0_16px_48px_rgba(2,8,23,0.28)] md:rounded-[26px] md:shadow-[0_20px_60px_rgba(2,8,23,0.35)]">
              <div className="pointer-events-none absolute inset-0 hidden bg-gradient-to-tr from-white/10 via-transparent to-transparent md:block"></div>
              <div className="pointer-events-none absolute inset-0 hidden bg-gradient-to-b from-transparent via-transparent to-slate-950/15 md:block"></div>
              <img
                alt="iPAY9 Online Casino Australia"
                className="relative z-10 mx-auto block h-auto max-h-[min(520px,62vh)] w-full object-contain object-top md:max-h-[min(560px,72vh)] lg:max-h-none"
                src="/hero-section-ambassador.png"
              />
              <div className="pointer-events-none absolute inset-x-6 top-4 hidden h-px bg-white/35 md:block"></div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 pb-10">
          <div className="glass-card-blue rounded-xl overflow-hidden !border-0 shadow-lg ring-1 ring-blue-200/25 group transition-all duration-300">
            <div className="flex items-start gap-3 sm:gap-4 p-4 sm:p-5">
              <div className="flex-1 min-w-0">
                <div className="flex flex-col gap-2 mb-2 sm:flex-row sm:flex-wrap sm:items-center">
                  <span className="text-blue-600 font-bold text-[10px] sm:text-xs uppercase tracking-wide leading-snug">DAILY DEPOSIT BONUS</span>
                  <span className="inline-flex w-fit shrink-0 bg-gradient-to-r from-blue-600 to-blue-500 text-white text-[10px] sm:text-xs font-bold px-2 py-1 rounded-md whitespace-nowrap">UP TO AUD 200</span>
                </div>
                <p className="text-slate-500 text-[11px] sm:text-xs leading-relaxed">Deposit AUD 100 to unlock daily rewards up to AUD 200. Check promo rules inside your iPAY9 account.</p>
              </div>
              <div className="aspect-square w-[88px] shrink-0 overflow-hidden rounded-xl bg-slate-50 ring-1 ring-blue-200/35 sm:w-20">
                <img alt="Daily Bonus" className="h-full w-full object-contain object-center" src="/casino-slot.webp" />
              </div>
            </div>
            <a href={AFFILIATE_URL} {...getAffiliateLinkProps('hero_daily_bonus', 'Get Bonus Now')} className="group/btn relative block overflow-hidden cursor-pointer">
              <div className="relative flex items-center justify-center gap-1.5 sm:gap-2 bg-gradient-to-r from-blue-700 via-blue-600 to-blue-500 py-3 px-3 sm:py-3.5 sm:px-6 transition-all duration-300 group-hover/btn:from-blue-600 group-hover/btn:via-blue-500 group-hover/btn:to-blue-400">
                <div className="absolute inset-0 bg-white/10 translate-x-[-100%] group-hover/btn:translate-x-[100%] transition-transform duration-500 skew-x-12"></div>
                <span className="relative z-10 flex flex-wrap items-center justify-center gap-1.5 sm:gap-2">
                  <i className="ri-gift-2-line text-blue-200 text-sm sm:text-base shrink-0"></i>
                  <span className="text-white text-xs sm:text-sm font-bold tracking-wide">Get Bonus Now</span>
                  <span className="bg-white/20 text-white text-[10px] sm:text-xs font-black px-2 py-0.5 rounded-full">UP TO AUD 200</span>
                  <i className="ri-arrow-right-line text-blue-200 text-sm shrink-0 transition-transform duration-300 group-hover/btn:translate-x-1"></i>
                </span>
              </div>
            </a>
          </div>

          <div className="glass-card-blue rounded-xl overflow-hidden !border-0 shadow-lg ring-1 ring-blue-200/25 group transition-all duration-300">
            <div className="flex items-start gap-3 sm:gap-4 p-4 sm:p-5">
              <div className="flex-1 min-w-0">
                <div className="flex flex-col gap-2 mb-2 sm:flex-row sm:flex-wrap sm:items-center">
                  <span className="text-blue-600 font-bold text-[10px] sm:text-xs uppercase tracking-wide leading-snug">MONTHLY DEPOSIT RANKING BONUS</span>
                  <span className="inline-flex w-fit shrink-0 bg-gradient-to-r from-blue-600 to-blue-500 text-white text-[10px] sm:text-xs font-bold px-2 py-1 rounded-md whitespace-nowrap">AUD 1999</span>
                </div>
                <p className="text-slate-500 text-[11px] sm:text-xs leading-relaxed">Compete in monthly deposit rankings and win up to AUD 1999 in exclusive leaderboard rewards.</p>
              </div>
              <div className="aspect-square w-[88px] shrink-0 overflow-hidden rounded-xl bg-slate-50 ring-1 ring-blue-200/35 sm:w-20">
                <img alt="Ranking Bonus" className="h-full w-full object-contain object-center" src="/casino-free.png" />
              </div>
            </div>
            <a href={AFFILIATE_URL} {...getAffiliateLinkProps('hero_monthly_bonus', 'Claim Bonus Now')} className="group/btn relative block overflow-hidden cursor-pointer">
              <div className="relative flex items-center justify-center gap-1.5 sm:gap-2 bg-gradient-to-r from-blue-800 via-blue-700 to-blue-600 py-3 px-3 sm:py-3.5 sm:px-6 transition-all duration-300 group-hover/btn:from-blue-700 group-hover/btn:via-blue-600 group-hover/btn:to-blue-500">
                <div className="absolute inset-0 bg-white/10 translate-x-[-100%] group-hover/btn:translate-x-[100%] transition-transform duration-500 skew-x-12"></div>
                <span className="relative z-10 flex flex-wrap items-center justify-center gap-1.5 sm:gap-2">
                  <i className="ri-sparkling-2-line text-blue-200 text-sm sm:text-base shrink-0"></i>
                  <span className="text-white text-xs sm:text-sm font-bold tracking-wide">Claim Bonus Now</span>
                  <span className="bg-white/20 text-white text-[10px] sm:text-xs font-black px-2 py-0.5 rounded-full">AUD 1999</span>
                  <i className="ri-arrow-right-line text-blue-200 text-sm shrink-0 transition-transform duration-300 group-hover/btn:translate-x-1"></i>
                </span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
